import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

/**
 * RGPD-1.5 — Footer global.
 *
 * Rendered in App.js OUTSIDE Layout (Option A audit), so it covers:
 * - auth pages (/auth, /forgot-password, etc.)
 * - public legal pages (/privacy, /terms, /legal)
 * - protected pages (/dashboard, etc.)
 */
const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="border-t border-gray-200 dark:border-gray-700 py-4 px-6 text-sm bg-white dark:bg-slate-900"
      data-testid="global-footer"
    >
      <div className="flex flex-wrap items-center justify-between gap-2 max-w-7xl mx-auto">
        <div className="flex flex-wrap items-center gap-3 text-gray-600 dark:text-gray-400">
          <Link
            to="/privacy"
            className="hover:text-blue-600 dark:hover:text-blue-400 transition"
          >
            {t('footer.privacy')}
          </Link>
          <span aria-hidden="true">·</span>
          <Link
            to="/terms"
            className="hover:text-blue-600 dark:hover:text-blue-400 transition"
          >
            {t('footer.terms')}
          </Link>
          <span aria-hidden="true">·</span>
          <Link
            to="/legal"
            className="hover:text-blue-600 dark:hover:text-blue-400 transition"
          >
            {t('footer.legal')}
          </Link>
        </div>
        <div className="text-gray-500 dark:text-gray-400">
          © {currentYear} WattEd Sàrl
          <span className="mx-1" aria-hidden="true">·</span>
          <a
            href="mailto:climat@fr.ch"
            className="hover:text-blue-600 dark:hover:text-blue-400 transition"
          >
            {t('footer.contact')}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
